import React from "react";
import FullScreenModal from "../FullScreenModal/FullScreenModal";
import { IReducer } from "../../state/reducer";
import { FullModalContainer } from "../FullModalContainer/FullModalContainer";
import { BrickInfoTotal } from "../../state/BrickInfoTotal/BrickInfoTotal";
import { ActionChange } from "../../state/BrickActions/ActionInfo/ActionInfo";
import { Check, X } from "react-feather";
import "./setDetails.css";

interface SetDetailsProps extends IReducer {
  setId: string;
  isOpen: boolean;
  onClose: (arg0: boolean) => void;
}

const SetDetails: React.FC<SetDetailsProps> = ({
  setId,
  isOpen,
  onClose,
  state,
}) => {
  const setEntry = state.sets.get(setId);
  const action = state.actions.get(`buy_set_${setId}`);

  if (!setEntry || !action) return null;

  const renderCosts = (_: number, cost: ActionChange) => {
    const trueCost =
      cost.baseChangeValue + action.costIncrement * action.costScale;
    const costType = cost.type || "brick";

    let currentAmount = 0;
    let capacity = 0;
    let name = "";
    let meetsRequirement = false;

    if (costType === "brick") {
      const brick = state.bricks.get(cost.brickId);
      currentAmount = brick?.amount ?? 0;
      capacity = brick?.capacity ?? 0;
      name = BrickInfoTotal.get(cost.brickId)?.name ?? cost.brickId;
      meetsRequirement =
        brick && !isNaN(brick.amount) && brick.amount >= trueCost;
    } else if (costType === "set") {
      const set = state.sets.get(cost.brickId); // brickId field contains set ID
      currentAmount = set?.count ?? 0;
      capacity = 0; // Sets don't have capacity
      name = set?.name ?? cost.brickId;
      meetsRequirement = set && set.count >= trueCost;
    }

    if (meetsRequirement) {
      return (
        <tr className="tableRow" key={cost.brickId}>
          <td className="tableCell">{name}</td>
          <td className="tableCell">{trueCost}</td>
          <td className="tableCell">
            <Check size={32} className="costIcon metCostIcon" />
          </td>
          <td className="tableCell">
            {currentAmount}
            {costType === "brick" ? ` / ${capacity}` : ""}
          </td>
        </tr>
      );
    } else {
      return (
        <tr className="tableRow" key={cost.brickId}>
          <td className="tableCell">{name}</td>
          <td className="tableCell">{trueCost}</td>
          <td className="tableCell">
            <X size={32} className="costIcon missingCostIcon" />
          </td>
          <td className="tableCell">
            {currentAmount}
            {costType === "brick" ? ` / ${capacity}` : ""}
          </td>
        </tr>
      );
    }
  };

  return (
    <FullScreenModal
      header={setEntry.name}
      isOpen={isOpen}
      onClose={() => onClose(false)}
      helpURL="https://www.google.com"
    >
      <div className="fullModalParent">
        <div className="setDetailsContainer">
          <div className="setImageContainer">
            <img
              src={setEntry.photo}
              alt={setEntry.name}
              className="setImage"
            />
          </div>
          <div className="setInfo">
            <table>
              <tbody>
                <tr>
                  <td className="setStatColumn">Set ID:</td>
                  <td>{setEntry.id}</td>
                </tr>
                <tr>
                  <td className="setStatColumn">Current Count:</td>
                  <td>{setEntry.count}</td>
                </tr>
                <tr>
                  <td className="setStatColumn">Total Purchases:</td>
                  <td>{state.setsPurchasedByType.get(setId) || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <FullModalContainer title={"Cost Breakdown"}>
          <table className="customTable">
            <thead className="tableHead">
              <tr>
                <th>Item</th>
                <th>Cost</th>
                <th>Meet Costs</th>
                <th>Amount{" / Capacity"}</th>
              </tr>
            </thead>
            <tbody>
              {action.cost.map((cost, index) => renderCosts(index, cost))}
            </tbody>
          </table>
        </FullModalContainer>
      </div>
    </FullScreenModal>
  );
};

export default SetDetails;
